import { DialogDismiss } from '@ariakit/react';
import { Drawer } from 'vaul';
import cn from 'classnames';
import React from 'react';
import { useModalContext } from '../Modal/components/ModalContext';
import ClosePopupIcon from '../assets/images/ClosePopup.svg';
import * as styles from './styles.module.css';

export function DialogCloseButton({ className }: { className?: string }) {
  const { isDrawer } = useModalContext();
  const WrapperCloseButton = isDrawer ? Drawer.Close : DialogDismiss;

  return (
    <WrapperCloseButton className={cn(styles.closeButtonContainer, className)}>
      <div className={styles.closeButton}>
        <img className={styles.icon} src={ClosePopupIcon} alt="Закрыть" />
      </div>
    </WrapperCloseButton>
  );
}
